interface IProps {
  size: number;
}

export const FolderIcon = ({ size }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0C2.17157 0 1.5 0.671573 1.5 1.5V2.25C1.5 2.2925 1.50177 2.33458 1.50523 2.37619C0.628606 2.68358 0 3.51838 0 4.5V13.5C0 14.7426 1.00736 15.75 2.25 15.75H15.75C16.9926 15.75 18 14.7426 18 13.5V4.5C18 3.25736 16.9926 2.25 15.75 2.25H8.90549C8.57245 0.95608 7.39788 0 6 0H3ZM7.29933 2.25C7.03997 1.80165 6.55521 1.5 6 1.5H3V2.25H7.29933ZM2.25 3.75C1.83579 3.75 1.5 4.08579 1.5 4.5V13.5C1.5 13.9142 1.83579 14.25 2.25 14.25H15.75C16.1642 14.25 16.5 13.9142 16.5 13.5V4.5C16.5 4.08579 16.1642 3.75 15.75 3.75H2.25Z"
      fill="currentColor"
    />
  </svg>
);
